import React from 'react';
import styles from './index.module.scss';

const Live = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='48.001'
        height='41.999'
        viewBox='0 0 48.001 41.999'
        className={className}
    >
        <path
            d='M47,42H9a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,9,0H47a5.006,5.006,0,0,1,5,5V37A5.006,5.006,0,0,1,47,42ZM38.767,15.327V27.909h7.29V25.857h-4.77v-3.33h4.23v-2h-4.23v-3.15h4.77V15.327Zm-14.688.018,4.608,12.564h3.06l4.608-12.564H33.673l-3.438,9.99-3.456-9.99Zm-4.914,0V27.909h2.52V15.345Zm-9.162,0V27.909h6.66v-2h-4.14V15.345Z'
            transform='translate(-4)'
            className={styles.light}
        />
    </svg>
);

export default Live;
